import React from "react";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import BilateralAssignedCollateral from "./BilateralAssignedCollateral";
import {
    amount, numberWithCommaEmptyValue
} from "../../utils/formatters/Numbers";
import {Growl} from "primereact/growl";
import NumberFormat from "react-number-format";
import {getZeroOrNewTitles, withoutComma} from "../../utils/calculate/Amount";

export default class BilateralAssignedCollateralContainer extends React.Component {
    constructor(props) {
        super(props);

        this.setCollateralDetail = this.setCollateralDetail.bind(this);
        this.styleInstrumentNumberTemplate = this.styleInstrumentNumberTemplate.bind(this);
        this.numberEditor = this.numberEditor.bind(this);
        this.onEditorValueChange = this.onEditorValueChange.bind(this);
        this.calculateSuggested = this.calculateSuggested.bind(this);
        this.updateCollateralMapToUnassign = this.updateCollateralMapToUnassign.bind(this);

        this.state = {
            collateralDetail: props.collateralDetail,
            isExcess: props.isExcess ?? false,
            collateralList: [],
            marketAmount: 0,
            guaranteedAmount: 0,
            loanAmount: 0,
            collateralToUnassignMap: new Map(),
        };
    }

    setCollateralDetail() {
        this.setState((prevState) => {
            let collateralDetail = prevState.collateralDetail;

            return{
                collateralList: collateralDetail.collateralDetailList,
                marketAmount: collateralDetail.totalAmount,
                guaranteedAmount: collateralDetail.discountedAmount,
            };
        });
    }

    styleInstrumentNumberTemplate(rowData, column) {
        return numberWithCommaEmptyValue(rowData[column.field], "right")
    }

    numberEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.newTitles}
            thousandSeparator={true}
            allowNegative={false}
            onChange={(e) => this.onEditorValueChange(props, e.target.value)}
            onBlur={(e) => this.calculateSuggested()}
        />;
    }

    onEditorValueChange(props, value) {
        let assignedCollaterals = [...props.value];
        let valueNumber = withoutComma(value);

        valueNumber = valueNumber > assignedCollaterals[props.rowIndex].title
            ? assignedCollaterals[props.rowIndex].title : valueNumber;
        assignedCollaterals[props.rowIndex][props.field] = valueNumber === 0 ? '' : valueNumber;

        this.setState({collateralList: assignedCollaterals});
        this.calculateAmounts(assignedCollaterals);
        this.updateCollateralMapToUnassign(props.rowData.id, valueNumber);
    }

    calculateAmounts(assignedCollaterals) {
        let guaranteedAmountTotal = 0;
        let marketAmountTotal = 0;

        for (const item of assignedCollaterals) {
            item['discountedAmount'] = this.getAmount(item['title'], item['newTitles'], item['discountedPrice']);
            item['amount'] = this.getAmount(item['title'], item['newTitles'], item['valuatedPrice']);
            guaranteedAmountTotal += item['discountedAmount'];
            marketAmountTotal += item['amount'];
        }

        this.setState({
            guaranteedAmount: guaranteedAmountTotal,
            marketAmount: marketAmountTotal,
        })
    }

    getAmount(actualTitles, newTitlesStr, price) {
        let newTitles = actualTitles - getZeroOrNewTitles(newTitlesStr);
        return price * newTitles;
    }

    calculateSuggested() {
        this.setState((prevState) => {
            let collateralList = [...prevState.collateralList];
            for (const item of collateralList) {
                item['suggested'] = this.getSuggestedTitles(
                    prevState.loanAmount, prevState.guaranteedAmount, item);
            }
            return{
                collateralList: collateralList,
            };
        });
    }

    getSuggestedTitles(loanAmount, guaranteedAmount, item) {
        let suggestedTitles = Math.floor((guaranteedAmount - loanAmount) / item['discountedPrice']);
        let newTitles = getZeroOrNewTitles(item['newTitles']);
        let titleDifference = item['title'] - newTitles;

        if ((suggestedTitles < 0) || (item['title'] === newTitles)) {
            suggestedTitles = 0;
        } else if (suggestedTitles > titleDifference) {
                suggestedTitles = titleDifference;
        }
        return suggestedTitles;
    }

    updateCollateralMapToUnassign(collateralId, newTitles) {
        this.setState((prevState) => {
            let collateralMap = prevState.collateralToUnassignMap;
            if(newTitles === 0) {
                collateralMap.delete(collateralId)
            } else {
                collateralMap.set(collateralId, newTitles)
            }
            return {collateralToUnassignMap: collateralMap};
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="Totales:" colSpan={this.state.isExcess ? 7 : 4} style={{textAlign: 'right'}}/>
                    <Column footer={amount(this.state.guaranteedAmount, 'right')}/>
                    <Column footer={amount(this.state.marketAmount, 'right')}/>
                </Row>
            </ColumnGroup>;


        return <BilateralAssignedCollateral
            collateralList={this.state.collateralList}
            isExcess={this.state.isExcess}
            footerColumnGroup={footerColumnGroup}
            messagesGrowl={messagesGrowl}
            styleInstrumentNumberTemplate={this.styleInstrumentNumberTemplate}
            numberEditor={this.numberEditor}
        />
    }
};